module.exports = __webpack_public_path__ + "static/media/30-sugarbush.16412732.jpg";